<template>
  <div>
    <div v-if="dataloaded == false" class="blackbox-loader"></div>

    <div v-if="dataloaded == true" >
      <v-card outlined> 
        <v-card-title>
          <v-text-field
            style="max-width: 300px;"
            v-model="search"
            :color="companyPrimaryColor"
            placeholder="Zoeken"
            outlined
            hide-details     
            :background-color="$vuetify.theme.themes[theme].background"                                            
            prepend-inner-icon="search"
            autocomplete="disabled"
            clearable>
          </v-text-field>
          <v-spacer></v-spacer>
          <div class="header-edit-button">
            <v-btn class="mx-2" fab dark :color="companyPrimaryColor" @click="newCompDialog = true">
              <v-icon dark>add</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="companies"
          :search="search"
          item-key="name"
          :itemsPerPage.sync="companyPages"
          hide-default-footer
          :no-results-text="`Geen resultaten gevonden voor: ${search}`"
          no-data-text="Nog geen aansluitingen toegevoegd"
          >

          <template v-slot:item="{item, isExpanded, expand, index}">
            <tr>
              <td>
                <div class="question-list-item active" v-bind:class="{  true: item.active }">
                  <div class="circle"></div>
                </div>
              </td>
              <td>{{ item.name }}</td>
              <td>
                <div>
                  <v-btn x-small block color="#333"  @click="copyVariableToClipboard( item.id, index )" style="color: #fff; text-transform: none;">{{ item.id }}</v-btn>
                  <div v-if="item.copy == false" class="copy-tag-url" @click="copyVariableToClipboard( item.id, index )"><v-icon small color="#333">mdi-content-copy</v-icon> Kopi&euml;er</div>
                  <div v-else class="copy-tag-url copied" >Gekopi&euml;erd</div>
                </div>
              </td>
              <td>
                <span v-for="(branch, index) in branches.filter(branch => branch.compId == item.id)" :key="index">
                  <span v-if="index == 0">{{ branches.filter(branch => branch.compId == item.id).length}} </span>
                </span>
              </td>
              <td>
                <span v-for="(type, index) in companyTypes" :key="index">
                  <span v-if="type.id == item.type">{{ type.name}} </span>
                </span>
              </td>
              <td>
                <span v-if="softwareTypes[item.type]">
                  <span v-for="(software, index) in softwareTypes[item.type]" :key="index">
                    <span v-if="software.id == item.software">{{ software.name}} </span>
                  </span>
                </span>
              </td>
              <td>
                <ul class="company-package-list" >
                <span v-for="(companyPackage, index) in item.packages" :key="index">
                  <span v-for="availablePackage in packages" :key="availablePackage.id">
                    <li class="company-package" v-if="companyPackage == availablePackage.id">{{ availablePackage.name}} </li>
                  </span>
                </span>
              </ul>
              </td>
              <td>
                <v-btn style="float: right;" icon class="mx-0" @click="editCompany(item)">
                  <v-icon small :color="$vuetify.theme.themes[theme].text">edit</v-icon>
                </v-btn>
              </td>
              <td>
                <v-btn style="float: right;" icon class="mx-0" @click="deleteCompanyModal(item)">
                  <v-icon small :color="$vuetify.theme.themes[theme].text">delete</v-icon>
                </v-btn>
              </td>
              <td>
                <v-btn icon @click="expand(true)" v-if="!isExpanded"><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_more</v-icon></v-btn>
                <v-btn icon @click="expand(false)" v-if="isExpanded"><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_less</v-icon></v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" style="padding: 0;">
              <v-card  flat style="border-bottom: 1px solid rgba(0,0,0,0.12);" :style="{backgroundColor: $vuetify.theme.themes[theme].menuhover, borderColor: $vuetify.theme.themes[theme].menuborder}">
                <v-card-text>
                  <b>Locaties</b>
                  <ul class="ma-0 pa-0 ml-4">
                    <li v-for="(branch, index) in branches.filter(branch => branch.compId == item.id)" :key="branch.id" style="display: list-item;">
                      <span v-if="index != branches.filter(branch => branch.compId == item.id).length - 1">{{ branch.branchName }}</span>
                      <span v-if="index == branches.filter(branch => branch.compId == item.id).length - 1">{{ branch.branchName }}</span>
                    </li>
                  </ul>
                </v-card-text>
              </v-card>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </div>

    <!-- / New Company Dialog \ -->
    <v-dialog v-model="newCompDialog" scrollable max-width="600px">
      <add-comp-form @newCompDialogChange="newCompDialog = $event" :packages="packages" :companyTypes="companyTypes" :softwareTypes="softwareTypes" @updateData="updateData(), partyAnimal()"></add-comp-form>
    </v-dialog>
    <!-- \ New Company Dialog / -->

    <!-- / Edit Company Dialog \ -->
    <edit-comp-form  :editCompDialog="editCompDialog" :packages="packages" :selectedCompany="selectedCompanyInfo" :selectedCompanyOriginal="selectedCompanyInfoOriginal" @editCompDialogChange="editCompDialog = $event" :companyTypes="companyTypes" :softwareTypes="softwareTypes"  @updateData="updateData()"></edit-comp-form>
    <!-- \ Edit Company Dialog / -->

    <!-- / Delete Company Dialog \ -->
    <v-dialog v-model="deleteCompanyData.dialog" scrollable max-width="400px">
      <v-card>
        <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
          <h2 style="color:white">{{ deleteCompanyData.name }} verwijderen? </h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="deleteCompanyData.dialog = false">
            <v-icon dark color="white">close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <p class="ma-0 py-4">{{ deleteCompanyData.name }} zal <strong>definitief verwijderd</strong> worden. Dit kan niet meer worden hersteld.</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-container grid-list-md fluid class="ma-0 pa-0">
            <v-layout row wrap class="ma-0 pa-0">
              <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
                <v-btn
                  outlined
                  depressed
                  :color="companySecondaryColor"
                  @click="deleteCompanyData.dialog = false"
                  >
                  Annuleren
                </v-btn>
              </v-flex>
              <v-flex xs12 md6 class="text-right">
                <v-btn
                  :depressed="deleteCompanyData.removing"
                  :disabled="deleteCompanyData.removing"
                  :dark="!deleteCompanyData.removing"
                  rounded
                  :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                  :color="companyPrimaryColor"
                  @click="deleteCompany()"
                  >
                  Verwijderen
                  <v-icon right dark>chevron_right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>

      </v-card>
    </v-dialog>
    <!-- \ Delete Company Dialog / -->

  </div>
</template>


<script>
// import { bus } from "../main";
import db from "../firebase/init";
import _ from "lodash";
import AddCompForm from "../components/modals/AddCompForm.vue";
import EditCompForm from "../components/modals/EditCompForm.vue";
import party from "party-js";

export default {
  components: {
    "add-comp-form": AddCompForm,
    "edit-comp-form": EditCompForm
  },
  props:{
    softwareTypes: Object,
    companyTypes: Array,
    packages: Array
  },
  name: "companies",
  data: () => ({
    search: "",
    companyPages: -1,
    dataloaded: false,
    editCompDialog: false,
    newCompDialog: false,
    selectedCompanyInfo: {
      colors: {
        primary: "#5f1d9a",
        secondary: "#e5007d"
      }
    },
    selectedCompanyInfoOriginal: {},
    removeBookings: "",
    selected: [],
    branches: [],
    companies: [],
    deleteCompanyData: {
      dialog: false,
      removing: false
    },
    headers: [
      {
        text: "",
        align: "right",
        value: "",
        sortable: false,
        width: "30px"
      },
      {
        text: "Naam aansluiting",
        align: "left",
        value: "name"
      },
      {
        text: "ID",
        align: "left",
        value: "id"
      },
      {
        text: "Locaties",
        align: "left",
        value: "branches"
      },
      {
        text: "Type",
        align: "left",
        value: "type"
      },
      {
        text: "Software",
        align: "left",
        value: "software"
      },
      {
        text: "Paketten",
        align: "left",
        value: "packages",
        sortable: false,
      },
      {
        text: "",
        align: "right",
        value: "edit",
        width: "40px"
      },
      {
        text: "",
        align: "right",
        value: "edit",
        width: "40px"
      },
      {
        text: "",
        align: "right",
        value: "",
        width: "40px"
      }
    ]
  }),

  created() {
    this.loadCompanies();
  },

  methods: {

    partyAnimal(){
      const element = document.getElementsByTagName("BODY")[0];
      party.confetti(element, { 
        shapes: ["square", "circle", "roundedRectangle"],
        count: 350,
        gravity: 10,
      });
    },

    updateData() {
      this.loadCompanies();
    },

    editCompany(item) {
      this.editedIndex = this.companies.indexOf(item);
      this.selectedCompanyInfo = Object.assign({}, item);
      this.selectedCompanyInfoOriginal = _.cloneDeep(this.selectedCompanyInfo);
      this.editCompDialog = true;
    },

    deleteCompanyModal(item) {
      this.deleteCompanyData.id = item.id;
      this.deleteCompanyData.name = item.name;
      this.deleteCompanyData.dialog = true;
      this.deleteCompanyData.removing = false;
    },

    deleteCompany(){
      this.deleteCompanyData.removing = true;

      db.collection("companies").doc(this.deleteCompanyData.id)
      .set({
        deleted: {
          deleted: true,
          deletedBy: `${this.userFirstName} ${this.userLastName}` ,
          deletedDate: new Date()
        }
      },{ merge: true})
      .then(()=>{
        this.companies.splice(this.companies.findIndex(company=> company.id == this.deleteCompanyData.id), 1)
        this.deleteCompanyData.dialog = false;
        this.deleteCompanyData.removing = false;
      })
      .catch(error=>{
        console.error("Error bij updaten Company Doc", error)
        this.deleteCompanyData.dialog = false;
        this.deleteCompanyData.removing = false;
      })
    },

    loadCompanies() {
      this.dataloaded = false
      db.collection("companies")
        .where("deleted.deleted", "==", false)
        .get()
        .then(snap => {
          this.companies = [];
          snap.forEach(doc => {
            let compCollection = doc.data();
            compCollection.id = doc.id;
            compCollection.copy = false;
            this.companies.push(compCollection);
          });
        })
        .then(()=>{
          this.loadBranches()
        })
        
    },
    loadBranches() {
      db.collection("branches")
        .get()
        .then(snap => {
          this.branches = [];
          snap.forEach(doc => {
            let branchCollection = doc.data();
            branchCollection.id = doc.id;
            this.branches.push(branchCollection);
          });
        })
        .then(()=>{
          this.dataloaded = true
        })
    },
    copyVariableToClipboard(text, index){
      console.log("index:", index)
      if (!navigator.clipboard) {
        // fallbackCopyTextToClipboard(text);
        return;
      }
      navigator.clipboard.writeText(text).then(()=> {
        this.companies.forEach(company =>{
          company.copy = false;
        })
        this.companies[index].copy = true;
        setTimeout(()=>{ 
          this.companies[index].copy = false;
        }, 1000);

      }, function(err) {
        console.error('Async: Could not copy text: ', err);
      });
    },
  },

  computed: {
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    }
  }
};
</script>
<style>
.company-package{
  display: list-item;
  margin: 0;
  font-size: 12px;
}

.company-package-list{
  padding: 5px 0;
}
.copy-tag-url{
  display: block;
  cursor: pointer!important;
  pointer-events: auto;
  text-align: center;
  color: #333;
  margin: 2px 0 0 0;
  font-size: 11px;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Opera and Firefox */
}

.copy-tag-url .v-icon{
  font-size: 11px!important;
}

.copy-tag-url.copied{
  font-style: italic;
  color: #000;
}

.copy-tag-url:hover{
  cursor: pointer!important;
  color: #000;
}
</style>
